import {Inject, Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {YzRoleSelectContactsComponent} from "./yz-role-select-contacts.component";
import {BASE_CLIENT, BaseClient} from '../../client/base.client';
import {TokenService} from "../../token/token.service";

@Injectable({
  providedIn: 'root'
})

export class YzRoleSelectContactsService {

  constructor(public dialog: MatDialog,
              @Inject(BASE_CLIENT) private client: BaseClient,
              private http: HttpClient,
              private tokenService: TokenService) {

  }


  /**
   * 选择人员
   * @param option
   */
  choosePeople(option: {roleGroupCode?: string, count?: number, defaultContacts?: Array<any>, userTypes?: string, onOk?: (value: any) => void }) {
    if (this.tokenService.get().accessToken) {
      const dialogRef = this.dialog.open(YzRoleSelectContactsComponent, {
        panelClass: 'yz-role-select-contacts-panel',
        closeOnNavigation: true,
        data: {
          roleGroupCode: option.roleGroupCode == undefined ? null : option.roleGroupCode,
          count: option.count == undefined ? 0 : option.count,
          defaultContacts: option.defaultContacts == undefined ? [] : option.defaultContacts,
          userTypes: option.userTypes == undefined ? null : option.userTypes
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (option.onOk) {
          option.onOk(result ? result : []);
        }
      });
    } else {
      alert('无法获取Token,请刷新！');
    }
  }


  /**
   * 获取角色组角色
   * @param roleGroupCode 角色组code
   */
  getGroupRole(roleGroupCode: string): Observable<Array<any>> {
    return this.http.post(`${this.client.gateway}/auth/baseRole/findGroupRole`,{
      roleGroupCode: roleGroupCode
    }).pipe(
      map((response: any) => {
        return response.data ? response.data : [];
      })
    );
  }

  /**
   * 查询人员列表
   * @param pageNum 当前页面
   * @param pageSize 每页条数
   * @param realName 姓名
   * @param roleId 角色id
   * @param userTypes 用户类型1,2,3,4逗号拼接：查询普通部门的用户（不包括学生）传“1,4”；查询学生用户传“2,3”；查询所有用户不传
   */
  getBaseUser(pageNum: number, pageSize: number, realName: string, roleId: string, userTypes: string): Observable<Array<any>> {
    return this.http.post(`${this.client.gateway}/auth/baseUser/queryListForPage`, {
      "pageNum": pageNum,
      "pageSize": pageSize,
      "pageParam": {
        "realName": realName,
        "roleId": roleId,
        "userTypes": userTypes
      }
    }).pipe(
      map((response: any) => {
        return response ? response : null;
      })
    );
  }

}

